export const BASE_URL = process.env.REACT_APP_API_URL + "/";

export const API_URL1 = `${BASE_URL}api/`;
export const SOCKET_URL = `${BASE_URL}`;


